import { Box } from '@/components/Box/Box';
import { Typography } from '@/components/Typography/Typography';
import { COLORS } from '@/styles/colors';

export const SubscriptionPaymentFailedSnackbarMessage = () => {
  return (
    <Box display='flex' flexDirection='column' rowGap='2px'>
      <Typography variant='bodySmall' color={COLORS.grey[200]} fontWeight='medium'>
        Subscription Payment is Failed
      </Typography>
      <Typography variant='caption' color={COLORS.grey[200]} fontWeight='medium'>
        The payment attempt was unsuccessful. This might be due to insufficient funds or a declined card.
      </Typography>
    </Box>
  );
};

export const SubscriptionPaymentSuccessSnackbarMessage = () => {
  return (
    <Box display='flex' flexDirection='column' rowGap='2px'>
      <Typography variant='bodySmall' color={COLORS.grey[200]} fontWeight='medium'>
        Subscription Payment is Successful.
      </Typography>
      <Typography variant='caption' color={COLORS.grey[200]} fontWeight='medium'>
        Thank you! Your subscription is now active. You can continue using all features without interruptions.
      </Typography>
    </Box>
  );
};
